// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardFormValidation = require("../wizard/WizardFormValidation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let WizardMlsTimingValidation = require("../wizard/WizardMlsTimingValidation.bs.js");
let PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.bs.js");
let PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.bs.js");
let PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Utils.mlsListingTypeV5_decode;

let DraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Utils.mlsListingTypeV5_fromString;

let DraftFragment = {
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, formState);
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let match$1 = draft$1.draftProperty.mlsListingType;
  let match$2 = formState$1.mlsStatus;
  switch (match$2) {
    case "OnMls" :
    case "OnMlsButAllowed" :
      break;
    default:
      return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
  }
  if (typeof mode !== "object") {
    if (match$1 !== "ACTIVE") {
      return {
        NAME: "Error",
        VAL: "alreadyOnMlsAndNotActive"
      };
    } else {
      return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
    }
  }
  switch (mode.TAG) {
    case "Edit" :
      if (match$1 === mode.savedMlsListingType) {
        return "Valid";
      }
      if (match$1 === undefined) {
        return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
      }
      if (match$1 !== "ACTIVE" && match$1 !== "OFF_MLS" && match$1 !== "COMING_SOON") {
        return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
      }
      switch (match$1) {
        case "ACTIVE" :
          return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
        case "COMING_SOON" :
        case "OFF_MLS" :
          return {
            NAME: "Error",
            VAL: "cannotChangeMlsListingTypeBecausePropertyIsOnMls"
          };
      }
    case "Rebroadcast" :
    case "BroadcastQuietSeller" :
      return WizardMlsTimingValidation.validateListingTypeRequired(match$1);
  }
}

let MLSListingType = {
  DraftFragment: DraftFragment,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment_mlsListingTypeV5_decode$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Utils.mlsListingTypeV5_decode;

let DraftFragment_mlsListingTypeV5_fromString$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Utils.mlsListingTypeV5_fromString;

let DraftFragment$1 = {
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode$1,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

let FormStateFragment_localDraftMlsStatus_decode$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment$1 = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode$1,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$1(draft, formState) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, formState);
  let today = CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(draft$1.timeZone)));
  let match$1 = draft$1.draftProperty;
  let match$2 = formState$1.mlsStatus;
  if (typeof mode !== "object") {
    let onMlsAt = match$1.onMlsAt;
    let exit = 0;
    switch (match$2) {
      case "OnMls" :
      case "OnMlsButAllowed" :
        exit = 2;
        break;
    }
    if (exit === 2) {
      if (onMlsAt === undefined) {
        return {
          NAME: "Error",
          VAL: "alreadyOnMlsAndAfterToday"
        };
      }
      let onMlsAt$1 = Primitive_option.valFromOption(onMlsAt);
      if (DateFns.isSameDay(CalendarDate.toLocalDate(onMlsAt$1), today) || DateFns.isBefore(CalendarDate.toLocalDate(onMlsAt$1), today)) {
        return "Valid";
      } else {
        return {
          NAME: "Error",
          VAL: "alreadyOnMlsAndAfterToday"
        };
      }
    }
  }
  let tmp;
  if (typeof mode !== "object") {
    tmp = true;
  } else {
    switch (mode.TAG) {
      case "Edit" :
      case "Rebroadcast" :
        tmp = false;
        break;
      case "BroadcastQuietSeller" :
        tmp = true;
        break;
    }
  }
  return WizardMlsTimingValidation.validateOnMlsAt(match$1.mlsListingType, match$1.onMlsAt, today, tmp, WizardMlsTimingValidation.classifyListingType);
}

let OnMLSAt = {
  DraftFragment: DraftFragment$1,
  FormStateFragment: FormStateFragment$1,
  useIsValid: useIsValid$1
};

function useIsValid$2() {
  return "Valid";
}

let WillShow = {
  useIsValid: useIsValid$2
};

function useIsValid$3() {
  return "Valid";
}

let WillAcceptOffers = {
  useIsValid: useIsValid$3
};

let convertFragment$4 = PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

let DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let convertFragment$5 = PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

let FormStateFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function use$6(draft, formState) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, formState);
  let onMlsValid = useIsValid$1(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let mlsListingTypeValid = useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  let willShowValid = "Valid";
  let willAcceptOffersValid = "Valid";
  return WizardFormValidation.allValid([
    WizardFormValidation.optResultToDummyStringResult(onMlsValid),
    WizardFormValidation.optResultToDummyStringResult(mlsListingTypeValid),
    willShowValid,
    willAcceptOffersValid
  ]);
}

exports.MLSListingType = MLSListingType;
exports.OnMLSAt = OnMLSAt;
exports.WillShow = WillShow;
exports.WillAcceptOffers = WillAcceptOffers;
exports.DraftFragment = DraftFragment$2;
exports.FormStateFragment = FormStateFragment$2;
exports.use = use$6;
/* date-fns Not a pure module */
